import { Component, Input } from '@angular/core';

@Component({
    selector: 'cb-alert-card-new',
    templateUrl: './alert-card.component.html',
    styleUrls: ['./alert-card.component.scss'],
    standalone: false
})
export class AlertCardComponent {

    @Input() public type: 'info' | 'warning' | 'success' | 'error' | '' | 'cancel';
    @Input() public message: string;
    @Input() public removeElevation = false;


    constructor() { }

    public get alertClass(): string {
        switch (this.type) {
            case 'info':
                return 'mat-accent';
            case 'warning':
                return 'mat-warn';
            case 'success':
                return 'mat-primary';
            case 'error':
                return 'mat-error';
            case 'cancel':
                return 'mat-error';
            default:
                return '';
        }
    }

    public get icon(): string {
        switch (this.type) {
            case 'info':
                return 'info';
            case 'warning':
                return 'warning';
            case 'success':
                return ' check_circle';
            case 'error':
                return 'error';
            case 'cancel':
                return 'block';
            default:
                return '';
        }
    }


}
